var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPuce2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.605,
    height: 35.605,
    viewBox: "0 0 35.605 35.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_puce2",
    d: "M27.4,11.854l-11.41,11.41L9.848,17.12,7.466,19.5l8.651,8.651L29.909,14.362ZM19.5,2.2a17.3,17.3,0,1,0,17.3,17.3A17.5,17.5,0,0,0,19.5,2.2Zm0,31.095A13.792,13.792,0,1,1,33.295,19.5,13.752,13.752,0,0,1,19.5,33.295Z",
    transform: "translate(-1.7 -1.7)",
    fill: "#4c7ea9",
    stroke: "#f9f9fa",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPuce2);
export default __webpack_public_path__ + "static/media/_icon_puce2.5e8ee3d60dadedd3ae657aa96877a461.svg";
export { ForwardRef as ReactComponent };